<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="ack01">
</a><a id="page_ix">
<h2 class="chaptertitle">Acknowledgments</h2>
<p class="body-text"><span class="dropcap">I</span> would like to express my gratitude to all the clients over the years who have helped me gain an understanding of the all-encompassing interplay between the cosmos and the individual. I thank the students at my courses and lectures—particularly the students of AstrologSkolen—who over a seven-year period of experiential play so enriched my knowledge of astrology. No words can express my appreciation of my own teacher, Tarab Tulku, without whom I may never have discovered how empowering the right view can be.</p>
</a></div><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?60054e2e